<template>
  <Layout>
    <div class="row">
      <div class="col-lg-12">
        <div class="card" id="orderList">

          <div class="card-body border border-dashed border-end-0 border-start-0" >
            <div class="row g-2">
              <div class="col-sm-6" style="display: flex;">
                <select class="form-select mb-3" v-model="selectVal" @change="seekFun">
                  <option v-for="(res,i) in selectList" :key="res.name" :value="i">{{$t(res.name)}}</option>
                </select>

              </div>
              <!--end col-->
              <div class="col-sm-auto ms-auto">
                <div class="list-grid-nav hstack gap-1">
                  <button v-if="isAdd" type="button" class="btn btn-success add-btn" data-bs-toggle="modal" id="create-btn"
                          data-bs-target="#showModal">
                    <i class="ri-add-line align-bottom me-1"></i> {{$t("addText")}}
                  </button>
                </div>
              </div>
              <!--end col-->
            </div>

              <!--<div class="row g-3">-->
                <!--<div class="col-xxl-5 col-sm-3 mb-3">-->
                  <!--<button type="button" class="btn btn-success add-btn" data-bs-toggle="modal" id="create-btn"-->
                          <!--data-bs-target="#showModal">-->
                    <!--<i class="ri-add-line align-bottom me-1"></i> {{$t("addText")}}-->
                  <!--</button>-->
                <!--</div>-->
                <!--&lt;!&ndash;end col&ndash;&gt;-->

              <!--</div>-->
              <!--end row-->
          </div>
          <div class="card-body pt-0">
            <!--餐馆-电-->
            <div v-if="selectVal==0">
              <div class="table-responsive table-card mb-1">

                <table class="table table-striped align-middle">
                  <thead class="text-muted table-light">
                  <tr>
                    <th scope="col">{{$t('restaurantKwh-table1')}}</th>
                    <th scope="col">{{$t('restaurantKwh-table2')}}</th>
                    <th scope="col">{{$t('restaurantKwh-table3')}}</th>
                    <th scope="col">{{$t('restaurantKwh-table4')}}</th>
                    <th scope="col">{{$t('restaurantKwh-table5')}}</th>
                    <th scope="col">{{$t('restaurantKwh-table6')}}</th>
                    <th scope="col">{{$t('restaurantKwh-table7')}}</th>
                    <th scope="col">{{$t('restaurantKwh-table8')}}</th>
                    <th scope="col">{{$t('restaurantKwh-table9')}}</th>
                    <th scope="col">{{$t("action")}}</th>
                  </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(res,index) in list" :key="res.id">
                      <td>{{res.udate}}</td>
                      <td>{{res.ltotal  }}</td>
                      <td>{{res.l1}}</td>
                      <td>{{res.l2total}}</td>
                      <td>{{res.l2}}</td>
                      <td>{{res.atotal}}</td>
                      <td>{{res.ttotal}}</td>
                      <td>{{res.price}}</td>
                      <td>{{res.tamount}}</td>

                      <td>
                        <div class="hstack gap-3 flex-wrap">
                          <a v-if="isEdit" href="javascript:void(0);" class="link-success fs-15" @click="getDeptMsg(res)" data-bs-toggle="modal" data-bs-target="#showAlterModal">
                            <i class="ri-edit-2-line"></i>
                          </a>

                          <a v-if="isDelete" href="javascript:void(0);" @click="deletedata(res.id,index)" class="link-danger fs-15">
                            <i class="ri-delete-bin-line"></i>
                          </a>
                          <!--<router-link class="fs-15" :to="`/structure-details?id=${res.id}`">-->
                            <!--<i class="ri-eye-fill align-middle"></i>-->
                          <!--</router-link>-->
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>

              </div>
              <paging :selectPage="page" :pagingTotality="sum_page" @previousPageFun="previousPageFun"></paging>
              <!--<paging :selectPage="page" :pagingTotality="10" @previousPageFun="previousPageFun"></paging>-->
              <!--添加-->
              <div class="modal fade " @click="resetListFun" id="showModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" style="min-width: 800px" @click.stop="">
                  <div class="modal-content">
                    <div class="modal-header bg-light p-3">
                      <h5 class="modal-title" id="exampleModalLabel">{{$t("addText")}}</h5>
                      <button type="button" @click="resetListFun" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                              id="close-modal"></button>
                    </div>
                    <div class="modal-body row">
                      <div class="col-md-12 mb-3">
                        <label class="form-label">{{$t("restaurantKwh-table1")}}</label>
                        <flat-pickr v-model="addInfo.udate" @change="serviceDateLogFun" :config="datetimeConfig" :placeholder="$t('placeholder1')"
                                    class="form-control"></flat-pickr>
                      </div>
                      <div class="col-md-6 mb-3">
                        <label class="form-label">{{$t("restaurantKwh-table2")}}</label>
                        <input type="number" @input="expendKwh" class="form-control" v-model="addInfo.ltotal" />
                      </div>
                      <div class="col-md-6 mb-3">
                        <label class="form-label">{{$t("restaurantKwh-table3")}}</label>
                        <input type="number" disabled class="form-control" v-model="addInfo.l1" />
                      </div>

                      <div class="col-md-6 mb-3">
                        <label class="form-label">{{$t("restaurantKwh-table4")}}</label>
                        <input type="number" @input="expendKwh" class="form-control" v-model="addInfo.l2total" />
                      </div>
                      <div class="col-md-6 mb-3">
                        <label class="form-label">{{$t("restaurantKwh-table5")}}</label>
                        <input type="number" disabled class="form-control" v-model="addInfo.l2" />
                      </div>

                      <div class="col-md-4 mb-3">
                        <label class="form-label">{{$t("restaurantKwh-table6")}}</label>
                        <input type="number" disabled class="form-control" v-model="addInfo.atotal" />
                      </div>
                      <div class="col-md-4 mb-3">
                        <label class="form-label">{{$t("restaurantKwh-table7")}}</label>
                        <input type="number" disabled class="form-control" v-model="addInfo.ttotal" />
                      </div>
                      <div class="col-md-4 mb-3">
                        <label class="form-label">{{$t("restaurantKwh-table8")}}</label>
                        <input type="number" disabled @input="expendKwh" class="form-control" v-model="addInfo.price" />
                      </div>
                      <div class="col-md-12 mb-3">
                        <label class="form-label">{{$t("restaurantKwh-table9")}}</label>
                        <input type="number" disabled class="form-control" v-model="addInfo.tamount" />
                      </div>


                    </div>
                      <div class="modal-footer">
                        <div class="hstack gap-2 justify-content-end">
                          <button type="button" @click="resetListFun" class="btn btn-light" data-bs-dismiss="modal" id="closemodal">
                            {{$t('close')}}
                          </button>
                          <button type="button" class="btn btn-success" id="add-btn" @click="addorder">
                            {{$t('addText')}}
                          </button>
                        </div>
                      </div>
                  </div>
                </div>
              </div>
              <!--编辑-->
              <div class="modal fade "  @click="resetListFun" id="showAlterModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" style="min-width: 800px" @click.stop="">
                  <div class="modal-content">
                    <div class="modal-header bg-light p-3">
                      <h5 class="modal-title" >{{$t('edit')}}</h5>
                      <button type="button"  @click="resetListFun" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body row">
                      <div class="col-md-12 mb-3">
                        <label class="form-label">{{$t("restaurantKwh-table1")}}</label>
                        <flat-pickr v-model="addInfo.udate" @change="serviceDateLogFun" :config="datetimeConfig" :placeholder="$t('placeholder1')"
                                    class="form-control"></flat-pickr>
                      </div>
                      <div class="col-md-6 mb-3">
                        <label class="form-label">{{$t("restaurantKwh-table2")}}</label>
                        <input type="number" @input="expendKwh" class="form-control" v-model="addInfo.ltotal" />
                      </div>
                      <div class="col-md-6 mb-3">
                        <label class="form-label">{{$t("restaurantKwh-table3")}}</label>
                        <input type="number" disabled class="form-control" v-model="addInfo.l1" />
                      </div>

                      <div class="col-md-6 mb-3">
                        <label class="form-label">{{$t("restaurantKwh-table4")}}</label>
                        <input type="number" @input="expendKwh" class="form-control" v-model="addInfo.l2total" />
                      </div>
                      <div class="col-md-6 mb-3">
                        <label class="form-label">{{$t("restaurantKwh-table5")}}</label>
                        <input type="number" disabled class="form-control" v-model="addInfo.l2" />
                      </div>

                      <div class="col-md-4 mb-3">
                        <label class="form-label">{{$t("restaurantKwh-table6")}}</label>
                        <input type="number" disabled class="form-control" v-model="addInfo.atotal" />
                      </div>
                      <div class="col-md-4 mb-3">
                        <label class="form-label">{{$t("restaurantKwh-table7")}}</label>
                        <input type="number" disabled class="form-control" v-model="addInfo.ttotal" />
                      </div>
                      <div class="col-md-4 mb-3">
                        <label class="form-label">{{$t("restaurantKwh-table8")}}</label>
                        <input type="number" disabled @input="expendKwh" class="form-control" v-model="addInfo.price" />
                      </div>
                      <div class="col-md-12 mb-3">
                        <label class="form-label">{{$t("restaurantKwh-table9")}}</label>
                        <input type="number" disabled class="form-control" v-model="addInfo.tamount" />
                      </div>


                    </div>
                      <div class="modal-footer">
                        <div class="hstack gap-2 justify-content-end">
                          <button type="button" @click="resetListFun" id="closeEditModal" class="btn btn-light" data-bs-dismiss="modal">
                            {{$t('cancel')}}
                          </button>
                          <button type="button" class="btn btn-success" @click="editDeptFun">
                            {{$t('confirm')}}
                          </button>
                        </div>
                      </div>
                  </div>
                </div>
              </div>

            </div>
            <!--餐馆-天然气-->
            <div v-if="selectVal==1">
              <div class="table-responsive table-card mb-1">

                <table class="table table-striped align-middle">
                  <thead class="text-muted table-light">
                  <tr>
                    <th scope="col">{{$t('restaurantGas-table1')}}</th>
                    <th scope="col">{{$t('restaurantGas-table2')}}</th>
                    <th scope="col">{{$t('restaurantGas-table3')}}</th>
                    <th scope="col">{{$t('restaurantGas-table4')}}</th>
                    <th scope="col">{{$t('restaurantGas-table5')}}</th>
                    <th scope="col">{{$t('restaurantGas-table6')}}</th>
                    <th scope="col">{{$t('restaurantGas-table7')}}</th>
                    <th scope="col">{{$t("action")}}</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(res,index) in list" :key="res.id">
                    <td>{{res.udate}}</td>
                    <td>{{res.ltotal}}</td>
                    <td>{{res.l1}}</td>
                    <td>{{res.l2total}}</td>
                    <td>{{res.l2}}</td>
                    <td>{{res.price}}</td>
                    <td>{{res.tamount}}</td>
                    <td>
                      <div class="hstack gap-3 flex-wrap">
                        <a v-if="isEdit" href="javascript:void(0);" class="link-success fs-15" @click="getDeptMsg(res)" data-bs-toggle="modal" data-bs-target="#showAlterModal">
                          <i class="ri-edit-2-line"></i>
                        </a>

                        <a v-if="isDelete" href="javascript:void(0);" @click="deletedata(res.id,index)" class="link-danger fs-15">
                          <i class="ri-delete-bin-line"></i>
                        </a>
                        <!--<router-link class="fs-15" :to="`/structure-details?id=${res.id}`">-->
                        <!--<i class="ri-eye-fill align-middle"></i>-->
                        <!--</router-link>-->
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>

              </div>
              <paging :selectPage="page" :pagingTotality="sum_page" @previousPageFun="previousPageFun"></paging>
              <!--<paging :selectPage="page" :pagingTotality="10" @previousPageFun="previousPageFun"></paging>-->
              <!--添加-->
              <div class="modal fade " @click="resetListFun" id="showModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" style="min-width: 800px" @click.stop="">
                  <div class="modal-content">
                    <div class="modal-header bg-light p-3">
                      <h5 class="modal-title" id="exampleModalLabel">{{$t("addText")}}</h5>
                      <button type="button" @click="resetListFun" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                              id="close-modal"></button>
                    </div>
                    <div class="modal-body row">
                      <div class="col-md-12 mb-3">
                        <label class="form-label">{{$t("restaurantKwh-table1")}}</label>
                        <flat-pickr v-model="addInfo.udate" @change="serviceDateLogFun" :config="datetimeConfig" :placeholder="$t('placeholder1')"
                                    class="form-control"></flat-pickr>
                      </div>
                      <div class="col-md-6 mb-3">
                        <label class="form-label">{{$t("restaurantGas-table2")}}</label>
                        <input type="text" class="form-control" @input="expendGas" v-model="addInfo.ltotal" />
                      </div>
                      <div class="col-md-6 mb-3">
                        <label class="form-label">{{$t("restaurantGas-table3")}}</label>
                        <input type="text" disabled class="form-control" v-model="addInfo.l1" />
                      </div>
                      <div class="col-md-6 mb-3">
                        <label class="form-label">{{$t("restaurantGas-table4")}}</label>
                        <input type="text" disabled class="form-control" v-model="addInfo.l2total" />
                      </div>
                      <div class="col-md-6 mb-3">
                        <label class="form-label">{{$t("restaurantGas-table5")}}</label>
                        <input type="text" disabled @input="expendGas" class="form-control" v-model="addInfo.l2" />
                      </div>
                      <div class="col-md-6 mb-3">
                        <label class="form-label">{{$t("restaurantGas-table6")}}</label>
                        <input type="text" disabled @input="expendGas" class="form-control" v-model="addInfo.price" />
                      </div>
                      <div class="col-md-6 mb-3">
                        <label class="form-label">{{$t("restaurantGas-table7")}}</label>
                        <input type="text" disabled class="form-control" v-model="addInfo.tamount" />
                      </div>


                    </div>
                    <div class="modal-footer">
                      <div class="hstack gap-2 justify-content-end">
                        <button type="button" @click="resetListFun" class="btn btn-light" data-bs-dismiss="modal" id="closemodal">
                          {{$t('close')}}
                        </button>
                        <button type="button" class="btn btn-success" id="add-btn" @click="addorder">
                          {{$t('addText')}}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!--编辑-->
              <div class="modal fade " @click="resetListFun" id="showAlterModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" style="min-width: 800px" @click.stop="">
                  <div class="modal-content">
                    <div class="modal-header bg-light p-3">
                      <h5 class="modal-title" >{{$t('edit')}}</h5>
                      <button type="button" @click="resetListFun" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body row">
                      <div class="col-md-12 mb-3">
                        <label class="form-label">{{$t("restaurantKwh-table1")}}</label>
                        <flat-pickr v-model="addInfo.udate" @change="serviceDateLogFun" :config="datetimeConfig" :placeholder="$t('placeholder1')"
                                    class="form-control"></flat-pickr>
                      </div>
                      <div class="col-md-6 mb-3">
                        <label class="form-label">{{$t("restaurantGas-table2")}}</label>
                        <input type="text" class="form-control" @input="expendGas" v-model="addInfo.ltotal" />
                      </div>
                      <div class="col-md-6 mb-3">
                        <label class="form-label">{{$t("restaurantGas-table3")}}</label>
                        <input type="text" disabled class="form-control" v-model="addInfo.l1" />
                      </div>
                      <div class="col-md-6 mb-3">
                        <label class="form-label">{{$t("restaurantGas-table4")}}</label>
                        <input type="text" disabled class="form-control" v-model="addInfo.l2total" />
                      </div>
                      <div class="col-md-6 mb-3">
                        <label class="form-label">{{$t("restaurantGas-table5")}}</label>
                        <input type="text" disabled @input="expendGas" class="form-control" v-model="addInfo.l2" />
                      </div>
                      <div class="col-md-6 mb-3">
                        <label class="form-label">{{$t("restaurantGas-table6")}}</label>
                        <input type="text" disabled @input="expendGas" class="form-control" v-model="addInfo.price" />
                      </div>
                      <div class="col-md-6 mb-3">
                        <label class="form-label">{{$t("restaurantGas-table7")}}</label>
                        <input type="text" disabled class="form-control" v-model="addInfo.tamount" />
                      </div>


                    </div>
                    <div class="modal-footer">
                      <div class="hstack gap-2 justify-content-end">
                        <button type="button" @click="resetListFun" id="closeEditModal" class="btn btn-light" data-bs-dismiss="modal">
                          {{$t('cancel')}}
                        </button>
                        <button type="button" class="btn btn-success" @click="editDeptFun">
                          {{$t('confirm')}}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
            <!--酒庄-电-->
            <div v-if="selectVal==2">

              <div class="table-responsive table-card mb-1">

                <table class="table table-striped align-middle">
                  <thead class="text-muted table-light">
                  <tr>
                    <th scope="col">{{$t('wineryKwh-table1')}}</th>
                    <th scope="col">{{$t('wineryKwh-table2')}}</th>
                    <th scope="col">{{$t('wineryKwh-table3')}}</th>
                    <th scope="col">{{$t('wineryKwh-table4')}}</th>
                    <th scope="col">{{$t('wineryKwh-table5')}}</th>
                    <th scope="col">{{$t('wineryKwh-table6')}}</th>
                    <th scope="col">{{$t('wineryKwh-table7')}}</th>
                    <th scope="col">{{$t("action")}}</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(res,index) in list" :key="res.id">
                    <td>{{res.udate}}</td>
                    <td>{{res.ltotal}}</td>
                    <td>{{res.l1}}</td>
                    <td>{{res.ttotal}}</td>
                    <td>{{res.atotal}}</td>
                    <td>{{res.price}}</td>
                    <td>{{res.tamount}}</td>
                    <td>
                      <div class="hstack gap-3 flex-wrap">
                        <a v-if="isEdit" href="javascript:void(0);" class="link-success fs-15" @click="getDeptMsg(res)" data-bs-toggle="modal" data-bs-target="#showAlterModal">
                          <i class="ri-edit-2-line"></i>
                        </a>

                        <a v-if="isDelete" href="javascript:void(0);" @click="deletedata(res.id,index)" class="link-danger fs-15">
                          <i class="ri-delete-bin-line"></i>
                        </a>
                        <!--<router-link class="fs-15" :to="`/structure-details?id=${res.id}`">-->
                        <!--<i class="ri-eye-fill align-middle"></i>-->
                        <!--</router-link>-->
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>

              </div>
              <paging :selectPage="page" :pagingTotality="sum_page" @previousPageFun="previousPageFun"></paging>
              <!--<paging :selectPage="page" :pagingTotality="10" @previousPageFun="previousPageFun"></paging>-->
              <!--添加-->
              <div class="modal fade " @click="resetListFun" id="showModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" style="min-width: 800px" @click.stop="">
                  <div class="modal-content">
                    <div class="modal-header bg-light p-3">
                      <h5 class="modal-title" id="exampleModalLabel">{{$t("addText")}}</h5>
                      <button type="button" @click="resetListFun" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                              id="close-modal"></button>
                    </div>
                    <div class="modal-body row">
                      <div class="col-md-12 mb-3">
                        <label class="form-label">{{$t("restaurantKwh-table1")}}</label>
                        <flat-pickr v-model="addInfo.udate" @change="serviceDateLogFun" :config="datetimeConfig" :placeholder="$t('placeholder1')"
                                    class="form-control"></flat-pickr>
                      </div>
                      <div class="col-md-4 mb-3">
                        <label class="form-label">{{$t("wineryKwh-table2")}}</label>
                        <input type="text" @input="chateauExpendKwh" class="form-control" v-model="addInfo.ltotal" />
                      </div>
                      <div class="col-md-4 mb-3">
                        <label class="form-label">{{$t("wineryKwh-table3")}}</label>
                        <input type="text" disabled class="form-control" v-model="addInfo.l1" />
                      </div>
                      <div class="col-md-4 mb-3">
                        <label class="form-label">{{$t("wineryKwh-table4")}}</label>
                        <input type="text" disabled class="form-control" v-model="addInfo.ttotal" />
                      </div>
                      <div class="col-md-4 mb-3">
                        <label class="form-label">{{$t("wineryKwh-table5")}}</label>
                        <input type="text" class="form-control" v-model="addInfo.atotal" />
                      </div>
                      <div class="col-md-4 mb-3">
                        <label class="form-label">{{$t("wineryKwh-table6")}}</label>
                        <input type="text" disabled @input="chateauExpendKwh" class="form-control" v-model="addInfo.price" />
                      </div>
                      <div class="col-md-4 mb-3">
                        <label class="form-label">{{$t("wineryKwh-table7")}}</label>
                        <input type="text" disabled class="form-control" v-model="addInfo.tamount" />
                      </div>


                    </div>
                    <div class="modal-footer">
                      <div class="hstack gap-2 justify-content-end">
                        <button type="button" @click="resetListFun" class="btn btn-light" data-bs-dismiss="modal" id="closemodal">
                          {{$t('close')}}
                        </button>
                        <button type="button" class="btn btn-success" id="add-btn" @click="addorder">
                          {{$t('addText')}}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!--编辑-->
              <div class="modal fade " @click="resetListFun" id="showAlterModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" style="min-width: 800px" @click.stop="">
                  <div class="modal-content">
                    <div class="modal-header bg-light p-3">
                      <h5 class="modal-title" >{{$t('edit')}}</h5>
                      <button type="button" @click="resetListFun" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body row">
                      <div class="col-md-12 mb-3">
                        <label class="form-label">{{$t("restaurantKwh-table1")}}</label>
                        <flat-pickr v-model="addInfo.udate" @change="serviceDateLogFun" :config="datetimeConfig" :placeholder="$t('placeholder1')"
                                    class="form-control"></flat-pickr>
                      </div>
                      <div class="col-md-4 mb-3">
                        <label class="form-label">{{$t("wineryKwh-table2")}}</label>
                        <input type="text" @input="chateauExpendKwh" class="form-control" v-model="addInfo.ltotal" />
                      </div>
                      <div class="col-md-4 mb-3">
                        <label class="form-label">{{$t("wineryKwh-table3")}}</label>
                        <input type="text" disabled class="form-control" v-model="addInfo.l1" />
                      </div>
                      <div class="col-md-4 mb-3">
                        <label class="form-label">{{$t("wineryKwh-table4")}}</label>
                        <input type="text" disabled class="form-control" v-model="addInfo.ttotal" />
                      </div>
                      <div class="col-md-4 mb-3">
                        <label class="form-label">{{$t("wineryKwh-table5")}}</label>
                        <input type="text" class="form-control" v-model="addInfo.atotal" />
                      </div>
                      <div class="col-md-4 mb-3">
                        <label class="form-label">{{$t("wineryKwh-table6")}}</label>
                        <input type="text" disabled @input="chateauExpendKwh" class="form-control" v-model="addInfo.price" />
                      </div>
                      <div class="col-md-4 mb-3">
                        <label class="form-label">{{$t("wineryKwh-table7")}}</label>
                        <input type="text" disabled class="form-control" v-model="addInfo.tamount" />
                      </div>


                    </div>
                    <div class="modal-footer">
                      <div class="hstack gap-2 justify-content-end">
                        <button type="button" @click="resetListFun" id="closeEditModal" class="btn btn-light" data-bs-dismiss="modal">
                          {{$t('cancel')}}
                        </button>
                        <button type="button" class="btn btn-success" @click="editDeptFun">
                          {{$t('confirm')}}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
            <!--酒庄-水-->
            <div v-if="selectVal==3">

              <div class="table-responsive table-card mb-1">

                <table class="table table-striped align-middle">
                  <thead class="text-muted table-light">
                  <tr>
                    <th scope="col">{{$t('wineryGallons-table1')}}</th>
                    <th scope="col">{{$t('wineryGallons-table2')}}</th>
                    <th scope="col">{{$t('wineryGallons-table3')}}</th>
                    <th scope="col">{{$t('wineryGallons-table4')}}</th>
                    <th scope="col">{{$t('wineryGallons-table5')}}</th>
                    <th scope="col">{{$t('wineryGallons-table6')}}</th>
                    <th scope="col">{{$t('wineryGallons-table7')}}</th>
                    <th scope="col">{{$t("action")}}</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(res,index) in list" :key="res.id">
                    <td>{{res.udate}}</td>
                    <td>{{res.ltotal}}</td>
                    <td>{{res.units}}</td>
                    <td>{{res.l1}}</td>
                    <td>{{res.units}}</td>
                    <td>{{res.price}}</td>
                    <td>{{res.tamount}}</td>

                    <td>
                      <div class="hstack gap-3 flex-wrap">
                        <a v-if="isEdit" href="javascript:void(0);" class="link-success fs-15" @click="getDeptMsg(res)" data-bs-toggle="modal" data-bs-target="#showAlterModal">
                          <i class="ri-edit-2-line"></i>
                        </a>

                        <a v-if="isDelete" href="javascript:void(0);" @click="deletedata(res.id,index)" class="link-danger fs-15">
                          <i class="ri-delete-bin-line"></i>
                        </a>
                        <!--<router-link class="fs-15" :to="`/structure-details?id=${res.id}`">-->
                        <!--<i class="ri-eye-fill align-middle"></i>-->
                        <!--</router-link>-->
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>

              </div>
              <paging :selectPage="page" :pagingTotality="sum_page" @previousPageFun="previousPageFun"></paging>
              <!--<paging :selectPage="page" :pagingTotality="10" @previousPageFun="previousPageFun"></paging>-->
              <!--添加-->
              <div class="modal fade " @click="resetListFun" id="showModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" style="min-width: 800px" @click.stop="">
                  <div class="modal-content">
                    <div class="modal-header bg-light p-3">
                      <h5 class="modal-title" id="exampleModalLabel">{{$t("addText")}}</h5>
                      <button type="button" @click="resetListFun" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                              id="close-modal"></button>
                    </div>
                    <div class="modal-body row">
                      <div class="col-md-12 mb-3">
                        <label class="form-label">{{$t("restaurantKwh-table1")}}</label>
                        <flat-pickr v-model="addInfo.udate" @change="serviceDateLogFun" :config="datetimeConfig" :placeholder="$t('placeholder1')"
                                    class="form-control"></flat-pickr>
                      </div>
                      <div class="col-md-4 mb-3">
                        <label class="form-label">{{$t("wineryGallons-table2")}}</label>
                        <input type="text" @input="chateauExpendWater" class="form-control" v-model="addInfo.ltotal" />
                      </div>
                      <div class="col-md-4 mb-3">
                        <label class="form-label">{{$t("wineryGallons-table3")}}</label>
                        <input type="text" class="form-control" v-model="addInfo.units" />
                      </div>
                      <div class="col-md-4 mb-3">
                        <label class="form-label">{{$t("wineryGallons-table4")}}</label>
                        <input type="text" disabled class="form-control" v-model="addInfo.l1" />
                      </div>
                      <div class="col-md-4 mb-3">
                        <label class="form-label">{{$t("wineryGallons-table5")}}</label>
                        <input type="text" class="form-control" v-model="addInfo.units" />
                      </div>
                      <div class="col-md-4 mb-3">
                        <label class="form-label">{{$t("wineryGallons-table6")}}</label>
                        <input type="text" @input="chateauExpendWater" class="form-control" v-model="addInfo.price" />
                      </div>
                      <div class="col-md-4 mb-3">
                        <label class="form-label">{{$t("wineryGallons-table7")}}</label>
                        <input type="text" disabled class="form-control" v-model="addInfo.tamount" />
                      </div>


                    </div>
                    <div class="modal-footer">
                      <div class="hstack gap-2 justify-content-end">
                        <button type="button" @click="resetListFun" class="btn btn-light" data-bs-dismiss="modal" id="closemodal">
                          {{$t('close')}}
                        </button>
                        <button type="button" class="btn btn-success" id="add-btn" @click="addorder">
                          {{$t('addText')}}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!--编辑-->
              <div class="modal fade " @click="resetListFun" id="showAlterModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" style="min-width: 800px" @click.stop="">
                  <div class="modal-content">
                    <div class="modal-header bg-light p-3">
                      <h5 class="modal-title" >{{$t('edit')}}</h5>
                      <button type="button" @click="resetListFun" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body row">
                      <div class="col-md-12 mb-3">
                        <label class="form-label">{{$t("restaurantKwh-table1")}}</label>
                        <flat-pickr v-model="addInfo.udate" @change="serviceDateLogFun" :config="datetimeConfig" :placeholder="$t('placeholder1')"
                                    class="form-control"></flat-pickr>
                      </div>
                      <div class="col-md-4 mb-3">
                        <label class="form-label">{{$t("wineryGallons-table2")}}</label>
                        <input type="text" @input="chateauExpendWater" class="form-control" v-model="addInfo.ltotal" />
                      </div>
                      <div class="col-md-4 mb-3">
                        <label class="form-label">{{$t("wineryGallons-table3")}}</label>
                        <input type="text" class="form-control" v-model="addInfo.units" />
                      </div>
                      <div class="col-md-4 mb-3">
                        <label class="form-label">{{$t("wineryGallons-table4")}}</label>
                        <input type="text" disabled class="form-control" v-model="addInfo.l1" />
                      </div>
                      <div class="col-md-4 mb-3">
                        <label class="form-label">{{$t("wineryGallons-table5")}}</label>
                        <input type="text" class="form-control" v-model="addInfo.units" />
                      </div>
                      <div class="col-md-4 mb-3">
                        <label class="form-label">{{$t("wineryGallons-table6")}}</label>
                        <input type="text" @input="chateauExpendWater" class="form-control" v-model="addInfo.price" />
                      </div>
                      <div class="col-md-4 mb-3">
                        <label class="form-label">{{$t("wineryGallons-table7")}}</label>
                        <input type="text" disabled class="form-control" v-model="addInfo.tamount" />
                      </div>


                    </div>
                    <div class="modal-footer">
                      <div class="hstack gap-2 justify-content-end">
                        <button type="button" @click="resetListFun" id="closeEditModal" class="btn btn-light" data-bs-dismiss="modal">
                          {{$t('cancel')}}
                        </button>
                        <button type="button" class="btn btn-success" @click="editDeptFun">
                          {{$t('confirm')}}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
            <!--酒庄-天然气-->
            <div v-if="selectVal==4">

              <div class="table-responsive table-card mb-1">

                <table class="table table-striped align-middle">
                  <thead class="text-muted table-light">
                  <tr>
                    <th scope="col">{{$t('wineryGas-table1')}}</th>
                    <th scope="col">{{$t('wineryGas-table2')}}</th>
                    <th scope="col">{{$t('wineryGas-table3')}}</th>
                    <th scope="col">{{$t('wineryGas-table4')}}</th>
                    <th scope="col">{{$t('wineryGas-table5')}}</th>
                    <th scope="col">{{$t('wineryGas-table6')}}</th>
                    <th scope="col">{{$t('wineryGas-table7')}}</th>
                    <th scope="col">{{$t("action")}}</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(res,index) in list" :key="res.id">
                    <td>{{res.udate}}</td>
                    <td>{{res.ltotal}}</td>
                    <td>{{res.l1}}</td>
                    <td>{{res.l2total}}</td>
                    <td>{{res.l2}}</td>
                    <td>{{res.price}}</td>
                    <td>{{res.tamount}}</td>
                    <td>
                      <div class="hstack gap-3 flex-wrap">
                        <a v-if="isEdit" href="javascript:void(0);" class="link-success fs-15" @click="getDeptMsg(res)" data-bs-toggle="modal" data-bs-target="#showAlterModal">
                          <i class="ri-edit-2-line"></i>
                        </a>

                        <a v-if="isDelete" href="javascript:void(0);" @click="deletedata(res.id,index)" class="link-danger fs-15">
                          <i class="ri-delete-bin-line"></i>
                        </a>
                        <!--<router-link class="fs-15" :to="`/structure-details?id=${res.id}`">-->
                        <!--<i class="ri-eye-fill align-middle"></i>-->
                        <!--</router-link>-->
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>

              </div>
              <paging :selectPage="page" :pagingTotality="sum_page" @previousPageFun="previousPageFun"></paging>
              <!--<paging :selectPage="page" :pagingTotality="10" @previousPageFun="previousPageFun"></paging>-->
              <!--添加-->
              <div class="modal fade " @click="resetListFun" id="showModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" style="min-width: 800px" @click.stop="">
                  <div class="modal-content">
                    <div class="modal-header bg-light p-3">
                      <h5 class="modal-title" id="exampleModalLabel">{{$t("addText")}}</h5>
                      <button type="button" @click="resetListFun" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                              id="close-modal"></button>
                    </div>
                    <div class="modal-body row">
                      <div class="col-md-12 mb-3">
                        <label class="form-label">{{$t("restaurantKwh-table1")}}</label>
                        <flat-pickr v-model="addInfo.udate" @change="serviceDateLogFun" :config="datetimeConfig" :placeholder="$t('placeholder1')"
                                    class="form-control"></flat-pickr>
                      </div>
                      <div class="col-md-6 mb-3">
                        <label class="form-label">{{$t("wineryGas-table2")}}</label>
                        <input type="text" @input="chateauExpendGas" class="form-control" v-model="addInfo.ltotal" />
                      </div>
                      <div class="col-md-6 mb-3">
                        <label class="form-label">{{$t("wineryGas-table3")}}</label>
                        <input type="text" disabled class="form-control" v-model="addInfo.l1" />
                      </div>
                      <div class="col-md-6 mb-3">
                        <label class="form-label">{{$t("wineryGas-table4")}}</label>
                        <input type="text" disabled class="form-control" v-model="addInfo.l2total" />
                      </div>
                      <div class="col-md-6 mb-3">
                        <label class="form-label">{{$t("wineryGas-table5")}}</label>
                        <input type="text" disabled class="form-control" v-model="addInfo.l2" />
                      </div>
                      <div class="col-md-6 mb-3">
                        <label class="form-label">{{$t("wineryGas-table6")}}</label>
                        <input type="text" disabled @input="chateauExpendGas" class="form-control" v-model="addInfo.price" />
                      </div>
                      <div class="col-md-6 mb-3">
                        <label class="form-label">{{$t("wineryGas-table7")}}</label>
                        <input type="text" disabled class="form-control" v-model="addInfo.tamount" />
                      </div>


                    </div>
                    <div class="modal-footer">
                      <div class="hstack gap-2 justify-content-end">
                        <button type="button" @click="resetListFun" class="btn btn-light" data-bs-dismiss="modal" id="closemodal">
                          {{$t('close')}}
                        </button>
                        <button type="button" class="btn btn-success" id="add-btn" @click="addorder">
                          {{$t('addText')}}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!--编辑-->
              <div class="modal fade " @click="resetListFun" id="showAlterModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" style="min-width: 800px" @click.stop="">
                  <div class="modal-content">
                    <div class="modal-header bg-light p-3">
                      <h5 class="modal-title" >{{$t('edit')}}</h5>
                      <button type="button" @click="resetListFun" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body row">
                      <div class="col-md-12 mb-3">
                        <label class="form-label">{{$t("restaurantKwh-table1")}}</label>
                        <flat-pickr v-model="addInfo.udate" @change="serviceDateLogFun" :config="datetimeConfig" :placeholder="$t('placeholder1')"
                                    class="form-control"></flat-pickr>
                      </div>
                      <div class="col-md-6 mb-3">
                        <label class="form-label">{{$t("wineryGas-table2")}}</label>
                        <input type="text" @input="chateauExpendGas" class="form-control" v-model="addInfo.ltotal" />
                      </div>
                      <div class="col-md-6 mb-3">
                        <label class="form-label">{{$t("wineryGas-table3")}}</label>
                        <input type="text" disabled class="form-control" v-model="addInfo.l1" />
                      </div>
                      <div class="col-md-6 mb-3">
                        <label class="form-label">{{$t("wineryGas-table4")}}</label>
                        <input type="text" disabled class="form-control" v-model="addInfo.l2total" />
                      </div>
                      <div class="col-md-6 mb-3">
                        <label class="form-label">{{$t("wineryGas-table5")}}</label>
                        <input type="text" disabled class="form-control" v-model="addInfo.l2" />
                      </div>
                      <div class="col-md-6 mb-3">
                        <label class="form-label">{{$t("wineryGas-table6")}}</label>
                        <input type="text" disabled @input="chateauExpendGas" class="form-control" v-model="addInfo.price" />
                      </div>
                      <div class="col-md-6 mb-3">
                        <label class="form-label">{{$t("wineryGas-table7")}}</label>
                        <input type="text" disabled class="form-control" v-model="addInfo.tamount" />
                      </div>


                    </div>
                    <div class="modal-footer">
                      <div class="hstack gap-2 justify-content-end">
                        <button type="button" @click="resetListFun" id="closeEditModal" class="btn btn-light" data-bs-dismiss="modal">
                          {{$t('cancel')}}
                        </button>
                        <button type="button" class="btn btn-success" @click="editDeptFun">
                          {{$t('confirm')}}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      <!--end col-->
    </div>
    <!--end row-->
  </Layout>
</template>
<script>
    import Swal from "sweetalert2";
    import Layout from "@/layouts/main.vue";
    import PageHeader from "@/components/page-header";
    import paging from "@/components/paging";
    import Lottie from "@/components/widgets/lottie.vue";
    import flatPickr from "vue-flatpickr-component";
    import {serviceList,service,serviceDel,serviceEdit,serviceDateLog} from "@/utils/allApi";
    export default {

        data() {
            return {
                selectVal:0,
                selectList:[
                    {name:'t-restaurantKwh',address:2,class:1},
                    {name:'t-restaurantGas',address:2,class:3},
                    {name:'t-wineryKwh',address:1,class:1},
                    {name:'t-wineryGallons',address:1,class:2},
                    {name:'t-wineryGas',address:1,class:3},
                ],
                upInfo:{
                    udate:0,//日期
                    l1:0,//电表1
                    l2:0,//电表2
                    lprice:0,//当日总消耗量1
                    l2price:0,//当日总消耗量2
                    ltotal:0,//l1 总数
                    l2total:0,//l2 总数
                    price:0,//单价
                    ttotal:0,//当日消耗总数
                    tamount:0,//当日消耗总价
                    atotal:0,//表总数
                    units:0,//单位
                },
                addInfo:{
                    address:2,//酒庄 1 餐馆 2
                    class:1,//电表 1 水 2 天然气 3
                    udate:'',//日期
                    l1:'',//电表1
                    l2:'',//电表2
                    lprice:'',//当日总消耗量1
                    l2price:'',//当日总消耗量2
                    ltotal:'',//l1 总数
                    l2total:'',//l2 总数
                    price:'',//单价
                    ttotal:'',//当日消耗总数
                    tamount:'',//当日消耗总价
                    atotal:'',//表总数
                    units:'',//单位
                },
            };
        },
        components: {
            Layout,
            PageHeader,paging,
            lottie: Lottie,
            flatPickr,
        },

        computed:{
            // 餐馆-电
            expendKwh(){
                if(this.addInfo.ltotal){
                    this.addInfo.l1 = (Number(this.addInfo.ltotal) - Number(this.upInfo.ltotal)).toFixed(2);
                }else{
                  this.addInfo.l1 = ''
                }
                if(this.addInfo.l2total){
                    this.addInfo.l2 = (Number(this.addInfo.l2total) - Number(this.upInfo.l2total)).toFixed(2);
                }else{
                  this.addInfo.l2 = ''
                }
                this.addInfo.atotal = (Number(this.addInfo.ltotal) + Number(this.addInfo.l2total)).toFixed(2);
                this.addInfo.ttotal = (Number(this.addInfo.l1) + Number(this.addInfo.l2)).toFixed(2);
                if(this.addInfo.ttotal!==''&&this.addInfo.price!==''){
                    this.addInfo.tamount = (Number(this.addInfo.ttotal) * Number(this.addInfo.price)).toFixed(2);
                }else{
                  this.addInfo.tamount = ''
                }

            },
            //餐馆-天然气
            expendGas(){
              if(this.addInfo.ltotal){
                this.addInfo.l1 = (Number(this.addInfo.ltotal) - Number(this.upInfo.ltotal)).toFixed(2);
                this.addInfo.l2total = (Number(this.addInfo.ltotal) * 28.3168).toFixed(2);
                this.addInfo.l2 = (Number(this.addInfo.l2total) - Number(this.upInfo.l2total)).toFixed(2);
              }else{
                this.addInfo.l1 = ''
                this.addInfo.l2total = ''
                this.addInfo.l2 = ''
              }

              if(this.addInfo.price!==''&&this.addInfo.ltotal!==''){
                this.addInfo.tamount = (Number(this.addInfo.price) * Number(this.addInfo.l2)).toFixed(2)
              }else{
                this.addInfo.tamount = ''
              }
            },
            //酒庄-电
            chateauExpendKwh(){
              if(this.addInfo.ltotal){
                this.addInfo.l1 = (Number(this.addInfo.ltotal) - Number(this.upInfo.ltotal)).toFixed(2)
                this.addInfo.ttotal = (Number(this.addInfo.l1) * 200).toFixed(2)
              }else{
                this.addInfo.l1 = '';
                this.addInfo.ttotal = '';
              }
              if(this.addInfo.price!==''&&this.addInfo.ttotal!==''){
                this.addInfo.tamount = (Number(this.addInfo.price) * Number(this.addInfo.ttotal)).toFixed(2)
              }else{
                this.addInfo.tamount = ''
              }
            },
            //酒庄-水
            chateauExpendWater(){
              if(this.addInfo.ltotal){
                this.addInfo.l1 = (Number(this.addInfo.ltotal) - Number(this.upInfo.ltotal)).toFixed(2)
              }else{
                this.addInfo.l1 = '';
              }
              if(this.addInfo.price!=='' && this.addInfo.l1!==''){
                this.addInfo.tamount = (Number(this.addInfo.price) * Number(this.addInfo.l1)).toFixed(2)
              }else{
                this.addInfo.tamount = ''
              }
            },
            //酒庄-天然气
            chateauExpendGas(){
              if(this.addInfo.ltotal){
                this.addInfo.l1 = (Number(this.addInfo.ltotal) - Number(this.upInfo.ltotal)).toFixed(2)
                this.addInfo.l2total = (Number(this.addInfo.ltotal) * 28.3168).toFixed(2)
                this.addInfo.l2 = (Number(this.addInfo.l2total) - Number(this.upInfo.l2total)).toFixed(2)
              }else{
                this.addInfo.l1 = ''
                this.addInfo.l2total = ''
                this.addInfo.l2 = ''
              }
              if(this.addInfo.price!==''&&this.addInfo.l2!==''){
                this.addInfo.tamount = (Number(this.addInfo.price) * Number(this.addInfo.l2)).toFixed(2)
              }else{
                this.addInfo.tamount = ''
              }
            }
        },

        mounted() {
            this.AuthorityFun('maintenances');
            this.getListFun();
        },
        methods: {
            seekFun(){
                this.page = 1;
                this.addInfo.address = this.selectList[this.selectVal].address
                this.addInfo.class = this.selectList[this.selectVal].class
                this.getListFun();

            },
            previousPageFun(e,type){
                this.page = e;
                if(type=='+'){this.page++}
                if(type=='-') {this.page--}
                this.list = [];
                this.getListFun();
            },
            //获取列表
            getListFun(){
                serviceList({
                    address:this.addInfo.address,
                    class:this.addInfo.class,
                    page:this.page,
                    limit:this.rows
                }).then(res=>{
                  this.list = res.data;
                  this.sum_page = res.sum_page;
                  this.resetListFun();
                })
            },

            getDeptMsg(item){
                this.addInfo = {
                        address:this.selectList[this.selectVal].address,//酒庄 1 餐馆 2
                        class:this.selectList[this.selectVal].class,//电表 1 水 2 天然气 3
                        udate:item.udate,//日期
                        id:item.id,
                        l1:item.l1,//电表1
                        l2:item.l2,//电表2
                        lprice:item.lprice,//当日总消耗量1
                        l2price:item.l2price,//当日总消耗量2
                        ltotal:item.ltotal,//l1 总数
                        l2total:item.l2total,//l2 总数
                        price:item.price,//单价
                        ttotal:item.ttotal,//当日消耗总数
                        tamount:item.tamount,//当日消耗总价
                        atotal:item.atotal,//表总数
                        units:item.units,//单位
                };
            },
            //删除
            deletedata(id,index) {
                Swal.fire({
                    title: this.$t('tooltip2'),
                    icon: "warning",
                    showCancelButton: true,
                    cancelButtonColor: "#f46a6a",
                    cancelButtonText: this.$t('cancel'),
                    confirmButtonColor: "#34c38f",
                    confirmButtonText: this.$t('confirm'),
                }).then((result) => {
                    if (result.value) {
                        serviceDel({
                            id:id,
                        }).then(res=>{
                            this.list.splice(index, 1);
                        })
                    }
                });
            },
            //添加
            addorder() {
                // if(
                //     this.addInfo.ltotal==''
                //     ||this.addInfo.l1==''
                //     ||this.addInfo.l2total==''
                //     ||this.addInfo.l2==''
                //     ||this.addInfo.atotal==''
                //     ||this.addInfo.ttotal==''
                //     ||this.addInfo.price==''
                //     ||this.addInfo.tamount==''
                // ){
                //     Swal.fire({title: this.$t('tooltip1')});
                //     return;
                // }
                service(this.addInfo).then(res=>{
                    this.resetFun();
                    this.getListFun();
                    document.getElementById('closemodal').click();

                })
            },
            resetListFun(){
                this.addInfo = {
                    address:this.selectList[this.selectVal].address,//酒庄 1 餐馆 2
                    class:this.selectList[this.selectVal].class,//电表 1 水 2 天然气 3
                    udate:'',//日期
                    l1:'',//电表1
                    l2:'',//电表2
                    lprice:'',//当日总消耗量1
                    l2price:'',//当日总消耗量2
                    ltotal:'',//l1 总数
                    l2total:'',//l2 总数
                    price:'',//单价
                    ttotal:'',//当日消耗总数
                    tamount:'',//当日消耗总价
                    atotal:'',//表总数
                    units:'',//单位
                };
                //餐馆——电
                if(this.addInfo.address==2&&this.addInfo.class==1){
                    // this.addInfo.price = 0.07827
                    this.addInfo.price = 0.08827
                }
                //餐馆——天然气
                if(this.addInfo.address==2&&this.addInfo.class==3){
                    this.addInfo.price = 0.7502
                }
                //酒庄——电
                if(this.addInfo.address==1&&this.addInfo.class==1){
                    // this.addInfo.price = 0.07827
                    this.addInfo.price = 0.08827
                }
                //酒庄——天然气
                if(this.addInfo.address==1&&this.addInfo.class==3){
                    this.addInfo.price = 0.7502
                }
            },
            editDeptFun(){
                serviceEdit(this.addInfo).then(res=>{
                    this.resetFun();
                    this.getListFun();
                    document.getElementById('closeEditModal').click();
                })
            },
            serviceDateLogFun(e){
                if(!this.addInfo.udate||this.addInfo.udate=='') return;
                serviceDateLog({
                    address:this.selectList[this.selectVal].address,//酒庄 1 餐馆 2
                    class:this.selectList[this.selectVal].class,//电表 1 水 2 天然气 3
                    date:this.addInfo.udate
                }).then(res=>{
                    // if(res.data.udate){
                    if(res.data.length!==0){
                        this.upInfo = res.data;
                    }else{
                      this.upInfo={
                        udate:0,//日期
                        l1:0,//电表1
                        l2:0,//电表2
                        lprice:0,//当日总消耗量1
                        l2price:0,//当日总消耗量2
                        ltotal:0,//l1 总数
                        l2total:0,//l2 总数
                        price:0,//单价
                        ttotal:0,//当日消耗总数
                        tamount:0,//当日消耗总价
                        atotal:0,//表总数
                        units:0,//单位
                      }
                    }
                    switch (this.selectVal) {
                      case 0:
                        this.expendKwh
                      break;
                      case 1:
                        this.expendGas
                      break;
                    }
                })
            }
        },
    };
</script>
